<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Account Verification</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Account Verification</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- In account-verification.component.html -->
<div class="login-area pt-100 col-lg-3 mx-auto">
    <div class="container">
        <h2>Verify Your Account</h2>
        <div *ngIf="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>
        <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <input type="email" class="form-control" placeholder="Your Email" formControlName="email">
            </div>
            <div class="form-group">
                <input type="text" class="form-control" placeholder="Enter Your 6 Digit Verification Code" formControlName="verificationCode">
            </div>

            <div class="text-center">
                <button type="submit" class="btn btn-primary" style="background-color: #201768;" [disabled]="verificationForm.invalid">Verify Account</button>
            </div>
            <div class="text-center mt-3">
                <button type="button" class="btn btn-secondary"
                        [disabled]="resendDisabled"
                        (click)="resendVerificationEmail()">
                    Resend Verification Code
                </button>
                <div *ngIf="resendCooldown > 0">
                    Please wait {{ resendCooldown }} seconds.
                </div>
            </div>
        </form>
    </div>
</div>

